import { buildCommunityGuidelinesURI, useConfig } from '@seek/libs-shared';
import { useTranslations } from '@vocab/react';
import {
  Card,
  IconClear,
  IconTick,
  Stack,
  Text,
  TextLink,
} from 'braid-design-system';

import translations from './.vocab';
interface BulletPointsItem {
  text: string;
}
interface CustomisedBulletPointsProps {
  items: BulletPointsItem[];
  type: 'do' | 'dont';
}

const CustomisedBulletPoints = ({ items, type }: CustomisedBulletPointsProps) =>
  items.map((item, index) => (
    <Text
      key={index}
      size="small"
      icon={
        type === 'do' ? (
          <IconTick tone="positive" />
        ) : (
          <IconClear tone="critical" />
        )
      }
    >
      {item.text}
    </Text>
  ));

export const ReviewGuidelines = () => {
  const { t } = useTranslations(translations);
  const { locale, zone, experience } = useConfig();
  const communityGuidelinesURL = buildCommunityGuidelinesURI({
    locale,
    zone,
    experience,
  });

  const doItem = [
    { text: t('Share honest opinions') },
    { text: t('Provide balanced feedback') },
  ];

  const dontItem = [
    { text: t('Name specific people') },
    { text: t('Use aggressive language') },
    { text: t('Share confidential information') },
  ];

  return (
    <Card>
      <Stack space="gutter">
        <Text weight="strong">{t('Review guidelines')}</Text>
        <Text weight="regular" size="small">
          {t('Ensure you stick to our community guidelines', {
            TextLink: (children: React.ReactNode[]) => (
              <TextLink
                href={communityGuidelinesURL}
                weight="weak"
                target="_blank"
              >
                {children}
              </TextLink>
            ),
          })}
        </Text>

        <Stack space="xsmall">
          <Text weight="strong" size="small">
            {t('Do')}:
          </Text>
          <CustomisedBulletPoints items={doItem} type="do" />
        </Stack>
        <Stack space="xsmall">
          <Text weight="strong" size="small">
            {t('Dont')}:
          </Text>
          <CustomisedBulletPoints items={dontItem} type="dont" />
        </Stack>
      </Stack>
    </Card>
  );
};
